// Forked from ../../ResultsDropdown/GroupCollections.tsx — keep in sync until phase_0 cleanup.
import React, { useContext } from 'react';
import { useTranslate } from '@bynder/localization';
import { IconInbox } from '@bynder/icons';
import type { CollectionsSearchResults } from '../../types';
import { iconSizeExtraLarge } from '../../../../helpers/iconSizes';
import { InfoContext } from '../../../../context';
import { addDomainToUrlIfNeeded } from '../../../../helpers/url';
import { navigateTo } from '../../../../helpers/windowLocation';
import { ListRow } from './ListRow';
import { getSpotlightResultClassName } from '../../helpers/getSpotlightResultClassName';
import { COLLECTION_NAME, parseHighlightedText } from '../../helpers/highlightedText';
import { StyledImgWrapper } from '../SharedComponents';
import { HighlightedText } from '../HighlightedText';

type Props = {
	collectionResults: CollectionsSearchResults;
};

export function GroupCollections({ collectionResults }: Props) {
	const { translate } = useTranslate();
	const {
		general: { portalDomain },
	} = useContext(InfoContext);

	return (
		<>
			{collectionResults.items.map((collection) => {
				const icon = collection.thumbnailUrl ? (
					<img
						src={addDomainToUrlIfNeeded(collection.thumbnailUrl, portalDomain)}
						alt=""
					/>
				) : (
					<IconInbox size={iconSizeExtraLarge} />
				);

				const linkToCollection = collection.path
					? collection.path
					: `/collections/view/${collection.id}/`;

				const totalFilesCount = collection.mediaCount ?? collection.assetCount;

				return (
					<ListRow
						dataId={collection.id}
						onSelect={() => navigateTo(linkToCollection)}
						className={getSpotlightResultClassName('Collection')}
						key={collection.id}
						thumbnail={<StyledImgWrapper>{icon}</StyledImgWrapper>}
						title={
							<HighlightedText
								segments={parseHighlightedText(collection.name, COLLECTION_NAME)}
							/>
						}
						subtext={`${totalFilesCount} ${translate(
							'spotlight.dropdown.collectionFiles',
						)}`}
					/>
				);
			})}
		</>
	);
}
